import React, { useMemo, useState } from "react";
import {
    Search,
    Eye,
    Pencil,
    Plus,
    Users,
    UserCheck,
    UserX,
    Clock3,
    Crown,
    Filter,
    X,
    ChevronLeft,
    ChevronRight,
    MapPin,
    GraduationCap,
    Heart,
    ShieldCheck,
    IndianRupee,
    CalendarDays,
    Phone,
    Mail,
    Briefcase,
    Home,
    Star,
    UserRound,
    Save,
} from "lucide-react";

/* =========================================================
   LOCATION MASTER
========================================================= */

const locationData = {
    "Tamil Nadu": {
        Erode: {
            Erode: ["Erode", "Veerappanchatram", "Surampatti"],
            Perundurai: ["Perundurai", "Vijayamangalam"],
            Bhavani: ["Bhavani", "Kavindapadi"],
        },
        Coimbatore: {
            Coimbatore: ["Coimbatore", "Gandhipuram", "RS Puram"],
            Pollachi: ["Pollachi", "Kinathukadavu"],
        },
        Salem: {
            Salem: ["Salem", "Hasthampatti", "Fairlands"],
            Attur: ["Attur", "Thalaivasal"],
        },
        Tiruppur: {
            Tiruppur: ["Tiruppur", "Avinashi Road"],
            Palladam: ["Palladam"],
        },
        Namakkal: {
            Namakkal: ["Namakkal"],
            Rasipuram: ["Rasipuram"],
        },
    },

    Kerala: {
        Ernakulam: {
            Ernakulam: ["Ernakulam"],
            Aluva: ["Aluva"],
        },
        Thrissur: {
            Thrissur: ["Thrissur"],
        },
    },

    Karnataka: {
        Bengaluru: {
            Bengaluru: ["Bengaluru"],
        },
        Mysore: {
            Mysore: ["Mysore"],
        },
    },
};

/* =========================================================
   MASTER OPTIONS
========================================================= */

const branchOptions = [
    "Erode Main Branch",
    "Coimbatore Branch",
    "Salem Branch",
    "Tiruppur Branch",
    "Namakkal Branch",
];

const communityOptions = [
    "Kongu Vellalar",
    "Gounder",
    "Nadar",
    "Naidu",
    "Chettiar",
    "Mudaliar",
    "Vanniyar",
    "Other",
];

const subCommunityOptions = [
    "Kongu Vellalar",
    "Vellala Gounder",
    "Nattu Gounder",
    "Other",
];

const casteOptions = [
    "Kongu Vellalar",
    "Gounder",
    "Nadar",
    "Naidu",
    "Chettiar",
    "Mudaliar",
    "Vanniyar",
    "Other",
];

const religionOptions = [
    "Hindu",
    "Christian",
    "Muslim",
    "Other",
];

const motherTongueOptions = [
    "Tamil",
    "English",
    "Malayalam",
    "Kannada",
    "Telugu",
    "Hindi",
    "Other",
];

const educationOptions = [
    "10th",
    "12th",
    "Diploma",
    "ITI",
    "UG",
    "PG",
    "Engineering",
    "Medical",
    "MBA",
    "CA",
    "Other",
];

const professionOptions = [
    "Software Engineer",
    "Business",
    "Doctor",
    "Teacher",
    "Government Employee",
    "Private Employee",
    "Engineer",
    "Accountant",
    "Lawyer",
    "Agriculture",
    "Other",
];

const occupationOptions = [
    "Business",
    "Private Job",
    "Government Job",
    "Self Employed",
    "Professional",
    "Agriculture",
    "Student",
    "Other",
];

const annualIncomeOptions = [
    "Below ₹2 Lakhs",
    "₹2 - ₹5 Lakhs",
    "₹5 - ₹10 Lakhs",
    "₹10 - ₹15 Lakhs",
    "₹15 - ₹25 Lakhs",
    "₹25 Lakhs +",
];

const maritalStatusOptions = [
    "Never Married",
    "Divorced",
    "Widowed",
    "Separated",
];

const familyTypeOptions = [
    "Joint Family",
    "Nuclear Family",
    "Extended Family",
];

const familyStatusOptions = [
    "Middle Class",
    "Upper Middle Class",
    "Rich",
    "Affluent",
];

const starOptions = [
    "Ashwini",
    "Bharani",
    "Karthigai",
    "Rohini",
    "Mirugaseerisham",
    "Thiruvathirai",
    "Punarpoosam",
    "Poosam",
    "Ayilyam",
    "Magam",
    "Pooram",
    "Uthiram",
    "Hastham",
    "Chithirai",
    "Swathi",
    "Visakam",
    "Anusham",
    "Kettai",
    "Moolam",
    "Pooradam",
    "Uthradam",
    "Thiruvonam",
    "Avittam",
    "Sathayam",
    "Poorattathi",
    "Uthirattathi",
    "Revathi",
];

const rasiOptions = [
    "Mesham",
    "Rishabam",
    "Mithunam",
    "Kadagam",
    "Simmam",
    "Kanni",
    "Thulam",
    "Viruchigam",
    "Dhanusu",
    "Makaram",
    "Kumbam",
    "Meenam",
];

const doshamOptions = [
    "No Dosham",
    "Chevvai Dosham",
    "Rahu Dosham",
    "Kethu Dosham",
    "Other",
];

const bodyTypeOptions = [
    "Slim",
    "Average",
    "Athletic",
    "Heavy",
];

const complexionOptions = [
    "Very Fair",
    "Fair",
    "Wheatish",
    "Dusky",
    "Dark",
];

const bloodGroupOptions = [
    "A+",
    "A-",
    "B+",
    "B-",
    "AB+",
    "AB-",
    "O+",
    "O-",
];

const subscriptionOptions = [
    "None",
    "Basic",
    "Premium",
    "Gold",
];

const profileCreatedByOptions = [
    "Self",
    "Parent",
    "Sibling",
    "Relative",
    "Staff",
];

const genderOptions = [
    "Male",
    "Female",
];

const statusOptions = [
    "Active",
    "Inactive",
    "Pending",
];

/* =========================================================
   INITIAL DATA
========================================================= */

const initialMembers = [
    {
        id: 1,
        memberId: "JP00001",
        name: "Arun Kumar",
        gender: "Male",
        dob: "1993-06-12",
        timeOfBirth: "08:30",
        placeOfBirth: "Erode",
        mobile: "9876543210",
        email: "arun@gmail.com",

        fatherName: "R. Kumar",
        motherName: "Lakshmi",
        siblings: "1 Brother",
        familyType: "Joint Family",
        familyStatus: "Upper Middle Class",
        familyTemple: "Mariyamman Temple",
        familyTemplePlace: "Erode",
        familyAssets: "Own House, Agriculture Land",

        community: "Kongu Vellalar",
        subCommunity: "Kongu Vellalar",
        caste: "Kongu Vellalar",
        religion: "Hindu",
        motherTongue: "Tamil",

        highestEducation: "Engineering",
        profession: "Software Engineer",
        occupation: "Private Job",
        companyName: "ABC Technologies",
        designation: "Senior Software Engineer",
        annualIncome: "₹10 - ₹15 Lakhs",
        workLocation: "Coimbatore",

        height: "5.8",
        weight: "72",
        complexion: "Fair",
        bodyType: "Athletic",
        maritalStatus: "Never Married",
        bloodGroup: "B+",

        country: "India",
        state: "Tamil Nadu",
        district: "Erode",
        taluk: "Erode",
        city: "Erode",
        pincode: "638001",
        nativePlace: "Erode",

        star: "Anusham",
        rasi: "Viruchigam",
        dosham: "No Dosham",
        horoscope: "Available",

        profilePicture: "",
        profileCreatedBy: "Self",
        subscriptionPlan: "Premium",
        branch: "Erode Main Branch",
        status: "Active",
        createdDate: "2026-09-20",
    },

    {
        id: 2,
        memberId: "JP00002",
        name: "Priya S",
        gender: "Female",
        dob: "1997-03-21",
        timeOfBirth: "06:45",
        placeOfBirth: "Coimbatore",
        mobile: "9876543211",
        email: "priya@gmail.com",

        fatherName: "S. Shankar",
        motherName: "Meena",
        siblings: "1 Sister",
        familyType: "Nuclear Family",
        familyStatus: "Upper Middle Class",
        familyTemple: "Murugan Temple",
        familyTemplePlace: "Coimbatore",
        familyAssets: "Own House",

        community: "Kongu Vellalar",
        subCommunity: "Vellala Gounder",
        caste: "Kongu Vellalar",
        religion: "Hindu",
        motherTongue: "Tamil",

        highestEducation: "MBA",
        profession: "HR Manager",
        occupation: "Private Job",
        companyName: "XYZ Private Limited",
        designation: "HR Manager",
        annualIncome: "₹5 - ₹10 Lakhs",
        workLocation: "Coimbatore",

        height: "5.4",
        weight: "58",
        complexion: "Wheatish",
        bodyType: "Average",
        maritalStatus: "Never Married",
        bloodGroup: "O+",

        country: "India",
        state: "Tamil Nadu",
        district: "Coimbatore",
        taluk: "Coimbatore",
        city: "Coimbatore",
        pincode: "641001",
        nativePlace: "Coimbatore",

        star: "Rohini",
        rasi: "Rishabam",
        dosham: "No Dosham",
        horoscope: "Available",

        profilePicture: "",
        profileCreatedBy: "Parent",
        subscriptionPlan: "Gold",
        branch: "Coimbatore Branch",
        status: "Active",
        createdDate: "2026-09-21",
    },

    {
        id: 3,
        memberId: "JP00003",
        name: "Karthik R",
        gender: "Male",
        dob: "1990-11-05",
        timeOfBirth: "10:15",
        placeOfBirth: "Salem",
        mobile: "9876543212",
        email: "karthik@gmail.com",

        fatherName: "R. Rajan",
        motherName: "Saraswathi",
        siblings: "2 Sisters",
        familyType: "Joint Family",
        familyStatus: "Middle Class",
        familyTemple: "Perumal Temple",
        familyTemplePlace: "Salem",
        familyAssets: "Own House",

        community: "Gounder",
        subCommunity: "Nattu Gounder",
        caste: "Gounder",
        religion: "Hindu",
        motherTongue: "Tamil",

        highestEducation: "Diploma",
        profession: "Business",
        occupation: "Business",
        companyName: "Karthik Traders",
        designation: "Proprietor",
        annualIncome: "₹15 - ₹25 Lakhs",
        workLocation: "Salem",

        height: "5.9",
        weight: "78",
        complexion: "Fair",
        bodyType: "Average",
        maritalStatus: "Never Married",
        bloodGroup: "A+",

        country: "India",
        state: "Tamil Nadu",
        district: "Salem",
        taluk: "Salem",
        city: "Salem",
        pincode: "636001",
        nativePlace: "Salem",

        star: "Hastham",
        rasi: "Kanni",
        dosham: "No Dosham",
        horoscope: "Available",

        profilePicture: "",
        profileCreatedBy: "Self",
        subscriptionPlan: "Basic",
        branch: "Salem Branch",
        status: "Pending",
        createdDate: "2026-09-23",
    },

    {
        id: 4,
        memberId: "JP00004",
        name: "Divya M",
        gender: "Female",
        dob: "1995-08-18",
        timeOfBirth: "04:20",
        placeOfBirth: "Tiruppur",
        mobile: "9876543213",
        email: "divya@gmail.com",

        fatherName: "M. Murugan",
        motherName: "Kala",
        siblings: "1 Brother",
        familyType: "Nuclear Family",
        familyStatus: "Upper Middle Class",
        familyTemple: "Amman Temple",
        familyTemplePlace: "Tiruppur",
        familyAssets: "Own House, Business",

        community: "Kongu Vellalar",
        subCommunity: "Kongu Vellalar",
        caste: "Kongu Vellalar",
        religion: "Hindu",
        motherTongue: "Tamil",

        highestEducation: "PG",
        profession: "Teacher",
        occupation: "Private Job",
        companyName: "ABC School",
        designation: "Teacher",
        annualIncome: "₹5 - ₹10 Lakhs",
        workLocation: "Tiruppur",

        height: "5.3",
        weight: "55",
        complexion: "Fair",
        bodyType: "Slim",
        maritalStatus: "Never Married",
        bloodGroup: "B+",

        country: "India",
        state: "Tamil Nadu",
        district: "Tiruppur",
        taluk: "Tiruppur",
        city: "Tiruppur",
        pincode: "641601",
        nativePlace: "Tiruppur",

        star: "Poosam",
        rasi: "Kadagam",
        dosham: "No Dosham",
        horoscope: "Available",

        profilePicture: "",
        profileCreatedBy: "Parent",
        subscriptionPlan: "Premium",
        branch: "Tiruppur Branch",
        status: "Active",
        createdDate: "2026-09-25",
    },
];

/* =========================================================
   EMPTY FORM
========================================================= */

const emptyForm = {
    memberId: "",
    name: "",
    gender: "Male",
    dob: "",
    timeOfBirth: "",
    placeOfBirth: "",
    mobile: "",
    email: "",

    fatherName: "",
    motherName: "",
    siblings: "",
    familyType: "",
    familyStatus: "",
    familyTemple: "",
    familyTemplePlace: "",
    familyAssets: "",

    community: "",
    subCommunity: "",
    caste: "",
    religion: "Hindu",
    motherTongue: "Tamil",

    highestEducation: "",
    profession: "",
    occupation: "",
    companyName: "",
    designation: "",
    annualIncome: "",
    workLocation: "",

    height: "",
    weight: "",
    complexion: "",
    bodyType: "",
    maritalStatus: "Never Married",
    bloodGroup: "",

    country: "India",
    state: "",
    district: "",
    taluk: "",
    city: "",
    pincode: "",
    nativePlace: "",

    star: "",
    rasi: "",
    dosham: "No Dosham",
    horoscope: "Available",

    profilePicture: "",
    profileCreatedBy: "Self",
    subscriptionPlan: "None",
    branch: "Erode Main Branch",
    status: "Active",
};

/* =========================================================
   HELPER COMPONENTS
========================================================= */

function FormInput({
    label,
    name,
    value,
    onChange,
    type = "text",
    required = false,
    placeholder = "",
}) {
    return (
        <div className="member-form-group">
            <label>
                {label}
                {required && <span>*</span>}
            </label>

            <input
                type={type}
                name={name}
                value={value || ""}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
            />
        </div>
    );
}

function FormSelect({
    label,
    name,
    value,
    onChange,
    options = [],
    required = false,
    disabled = false,
}) {
    return (
        <div className="member-form-group">
            <label>
                {label}
                {required && <span>*</span>}
            </label>

            <select
                name={name}
                value={value || ""}
                onChange={onChange}
                required={required}
                disabled={disabled}
            >
                <option value="">Select {label}</option>

                {options.map((option) => (
                    <option key={option} value={option}>
                        {option}
                    </option>
                ))}
            </select>
        </div>
    );
}

function FormSection({ icon: Icon, title, children }) {
    return (
        <div className="member-form-section">
            <div className="member-form-section-title">
                <div className="member-form-section-icon">
                    <Icon size={18} />
                </div>
                <h3>{title}</h3>
            </div>

            <div className="member-form-grid">
                {children}
            </div>
        </div>
    );
}

/* =========================================================
   MAIN COMPONENT
========================================================= */

function Members() {
    const [members, setMembers] = useState(initialMembers);

    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [branchFilter, setBranchFilter] = useState("");
    const [genderFilter, setGenderFilter] = useState("");
    const [subscriptionFilter, setSubscriptionFilter] = useState("");

    const [showFilters, setShowFilters] = useState(false);

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [showFormModal, setShowFormModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [editingMember, setEditingMember] = useState(null);
    const [viewingMember, setViewingMember] = useState(null);

    const [formData, setFormData] = useState(emptyForm);

    /* =====================================================
       SUMMARY
    ===================================================== */

    const totalMembers = members.length;

    const activeMembers = members.filter(
        (item) => item.status === "Active"
    ).length;

    const inactiveMembers = members.filter(
        (item) => item.status === "Inactive"
    ).length;

    const pendingMembers = members.filter(
        (item) => item.status === "Pending"
    ).length;

    const subscriptionMembers = members.filter(
        (item) =>
            item.subscriptionPlan &&
            item.subscriptionPlan !== "None"
    ).length;

    /* =====================================================
       FILTER
    ===================================================== */

    const filteredMembers = useMemo(() => {
        const searchText = search.trim().toLowerCase();

        return members.filter((member) => {
            const matchesSearch =
                !searchText ||
                member.memberId?.toLowerCase().includes(searchText) ||
                member.name?.toLowerCase().includes(searchText) ||
                member.mobile?.toLowerCase().includes(searchText) ||
                member.community?.toLowerCase().includes(searchText) ||
                member.caste?.toLowerCase().includes(searchText);

            const matchesStatus =
                !statusFilter ||
                member.status === statusFilter;

            const matchesBranch =
                !branchFilter ||
                member.branch === branchFilter;

            const matchesGender =
                !genderFilter ||
                member.gender === genderFilter;

            const matchesSubscription =
                !subscriptionFilter ||
                member.subscriptionPlan === subscriptionFilter;

            return (
                matchesSearch &&
                matchesStatus &&
                matchesBranch &&
                matchesGender &&
                matchesSubscription
            );
        });
    }, [
        members,
        search,
        statusFilter,
        branchFilter,
        genderFilter,
        subscriptionFilter,
    ]);

    /* =====================================================
       PAGINATION
    ===================================================== */

    const totalPages = Math.max(
        1,
        Math.ceil(filteredMembers.length / rowsPerPage)
    );

    const currentPage = Math.min(page, totalPages);

    const startIndex =
        (currentPage - 1) * rowsPerPage;

    const paginatedMembers = filteredMembers.slice(
        startIndex,
        startIndex + rowsPerPage
    );

    /* =====================================================
       LOCATION OPTIONS
    ===================================================== */

    const states = Object.keys(locationData);

    const districts = formData.state
        ? Object.keys(locationData[formData.state] || {})
        : [];

    const taluks =
        formData.state && formData.district
            ? Object.keys(
                  locationData[formData.state]?.[
                      formData.district
                  ] || {}
              )
            : [];

    const cities =
        formData.state &&
        formData.district &&
        formData.taluk
            ? locationData[formData.state]?.[
                  formData.district
              ]?.[formData.taluk] || []
            : [];

    /* =====================================================
       FORM CHANGE
    ===================================================== */

    const handleFormChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => {
            const updated = {
                ...prev,
                [name]: value,
            };

            if (name === "state") {
                updated.district = "";
                updated.taluk = "";
                updated.city = "";
            }

            if (name === "district") {
                updated.taluk = "";
                updated.city = "";
            }

            if (name === "taluk") {
                updated.city = "";
            }

            return updated;
        });
    };

    /* =====================================================
       OPEN ADD
    ===================================================== */

    const openAdd = () => {
        const nextId =
            Math.max(
                0,
                ...members.map((item) => item.id)
            ) + 1;

        const memberId = `JP${String(nextId).padStart(
            5,
            "0"
        )}`;

        setEditingMember(null);

        setFormData({
            ...emptyForm,
            memberId,
        });

        setShowFormModal(true);
    };

    /* =====================================================
       OPEN EDIT
    ===================================================== */

    const openEdit = (member) => {
        setEditingMember(member);

        setFormData({
            ...emptyForm,
            ...member,
        });

        setShowFormModal(true);
    };

    /* =====================================================
       OPEN VIEW
    ===================================================== */

    const openView = (member) => {
        setViewingMember(member);
        setShowViewModal(true);
    };

    /* =====================================================
       CLOSE FORM
    ===================================================== */

    const closeForm = () => {
        setShowFormModal(false);
        setEditingMember(null);
        setFormData(emptyForm);
    };

    /* =====================================================
       SAVE / UPDATE
    ===================================================== */

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.name.trim()) {
            alert("Please enter member name.");
            return;
        }

        if (!formData.mobile.trim()) {
            alert("Please enter mobile number.");
            return;
        }

        if (!formData.branch) {
            alert("Please select branch.");
            return;
        }

        if (editingMember) {
            setMembers((prev) =>
                prev.map((item) =>
                    item.id === editingMember.id
                        ? {
                              ...item,
                              ...formData,
                          }
                        : item
                )
            );

            alert("Member updated successfully.");
        } else {
            const newMember = {
                id:
                    Math.max(
                        0,
                        ...members.map((item) => item.id)
                    ) + 1,

                ...formData,

                createdDate:
                    new Date()
                        .toISOString()
                        .split("T")[0],
            };

            setMembers((prev) => [
                newMember,
                ...prev,
            ]);

            alert("Member added successfully.");
        }

        closeForm();
    };

    /* =====================================================
       TOGGLE STATUS
    ===================================================== */

    const toggleStatus = (member) => {
        const newStatus =
            member.status === "Active"
                ? "Inactive"
                : "Active";

        setMembers((prev) =>
            prev.map((item) =>
                item.id === member.id
                    ? {
                          ...item,
                          status: newStatus,
                      }
                    : item
            )
        );
    };

    /* =====================================================
       RESET FILTERS
    ===================================================== */

    const resetFilters = () => {
        setSearch("");
        setStatusFilter("");
        setBranchFilter("");
        setGenderFilter("");
        setSubscriptionFilter("");
        setPage(1);
    };

    /* =====================================================
       RENDER
    ===================================================== */

    return (
        <div className="members-page">

            {/* =================================================
                PAGE HEADER
            ================================================= */}

            <div className="members-page-header">
                <div>
                    <h1>Members</h1>

                    <p>
                        Manage matrimonial member profiles,
                        subscriptions and account status.
                    </p>
                </div>

                <button
                    type="button"
                    className="member-add-btn"
                    onClick={openAdd}
                >
                    <Plus size={18} />
                    Add Member
                </button>
            </div>

            {/* =================================================
                SUMMARY CARDS
            ================================================= */}

            <div className="member-summary-grid">

                <div className="member-summary-card">
                    <div className="member-summary-icon blue">
                        <Users size={22} />
                    </div>

                    <div>
                        <span>Total Members</span>
                        <strong>{totalMembers}</strong>
                    </div>
                </div>

                <div className="member-summary-card">
                    <div className="member-summary-icon green">
                        <UserCheck size={22} />
                    </div>

                    <div>
                        <span>Active Members</span>
                        <strong>{activeMembers}</strong>
                    </div>
                </div>

                <div className="member-summary-card">
                    <div className="member-summary-icon red">
                        <UserX size={22} />
                    </div>

                    <div>
                        <span>Inactive</span>
                        <strong>{inactiveMembers}</strong>
                    </div>
                </div>

                <div className="member-summary-card">
                    <div className="member-summary-icon orange">
                        <Clock3 size={22} />
                    </div>

                    <div>
                        <span>Pending</span>
                        <strong>{pendingMembers}</strong>
                    </div>
                </div>

                <div className="member-summary-card">
                    <div className="member-summary-icon pink">
                        <Crown size={22} />
                    </div>

                    <div>
                        <span>Subscribers</span>
                        <strong>
                            {subscriptionMembers}
                        </strong>
                    </div>
                </div>

            </div>

            {/* =================================================
                FILTER AREA
            ================================================= */}

            <div className="members-filter-card">

                <div className="members-filter-top">

                    <div className="member-search-box">
                        <Search size={18} />

                        <input
                            type="text"
                            placeholder="Search Member ID, Name, Mobile, Community..."
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(1);
                            }}
                        />

                        {search && (
                            <button
                                type="button"
                                onClick={() => {
                                    setSearch("");
                                    setPage(1);
                                }}
                            >
                                <X size={16} />
                            </button>
                        )}
                    </div>

                    <button
                        type="button"
                        className={`member-filter-toggle ${
                            showFilters ? "active" : ""
                        }`}
                        onClick={() =>
                            setShowFilters((prev) => !prev)
                        }
                    >
                        <Filter size={17} />
                        Filters
                    </button>

                </div>

                {showFilters && (
                    <div className="members-filter-grid">

                        <div>
                            <label>Branch</label>

                            <select
                                value={branchFilter}
                                onChange={(e) => {
                                    setBranchFilter(
                                        e.target.value
                                    );
                                    setPage(1);
                                }}
                            >
                                <option value="">
                                    All Branches
                                </option>

                                {branchOptions.map(
                                    (item) => (
                                        <option
                                            key={item}
                                            value={item}
                                        >
                                            {item}
                                        </option>
                                    )
                                )}
                            </select>
                        </div>

                        <div>
                            <label>Gender</label>

                            <select
                                value={genderFilter}
                                onChange={(e) => {
                                    setGenderFilter(
                                        e.target.value
                                    );
                                    setPage(1);
                                }}
                            >
                                <option value="">
                                    All Gender
                                </option>

                                {genderOptions.map(
                                    (item) => (
                                        <option
                                            key={item}
                                            value={item}
                                        >
                                            {item}
                                        </option>
                                    )
                                )}
                            </select>
                        </div>

                        <div>
                            <label>Status</label>

                            <select
                                value={statusFilter}
                                onChange={(e) => {
                                    setStatusFilter(
                                        e.target.value
                                    );
                                    setPage(1);
                                }}
                            >
                                <option value="">
                                    All Status
                                </option>

                                {statusOptions.map(
                                    (item) => (
                                        <option
                                            key={item}
                                            value={item}
                                        >
                                            {item}
                                        </option>
                                    )
                                )}
                            </select>
                        </div>

                        <div>
                            <label>Subscription</label>

                            <select
                                value={subscriptionFilter}
                                onChange={(e) => {
                                    setSubscriptionFilter(
                                        e.target.value
                                    );
                                    setPage(1);
                                }}
                            >
                                <option value="">
                                    All Plans
                                </option>

                                {subscriptionOptions
                                    .filter(
                                        (item) =>
                                            item !== "None"
                                    )
                                    .map((item) => (
                                        <option
                                            key={item}
                                            value={item}
                                        >
                                            {item}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className="filter-reset-wrapper">
                            <button
                                type="button"
                                className="filter-reset-btn"
                                onClick={resetFilters}
                            >
                                Reset Filters
                            </button>
                        </div>

                    </div>
                )}

            </div>

            {/* =================================================
                TABLE
            ================================================= */}

            <div className="members-table-card">

                <div className="members-table-header">
                    <div>
                        <h2>Member List</h2>

                        <span>
                            {filteredMembers.length} members
                            found
                        </span>
                    </div>
                </div>

                <div className="members-table-wrapper">

                    <table className="members-table">

                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Member</th>
                                <th>Mobile</th>
                                <th>Gender</th>
                                <th>Age</th>
                                <th>Community</th>
                                <th>Education</th>
                                <th>Profession</th>
                                <th>Branch</th>
                                <th>Plan</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>

                            {paginatedMembers.length === 0 ? (
                                <tr>
                                    <td
                                        colSpan="12"
                                        className="members-empty"
                                    >
                                        No members found.
                                    </td>
                                </tr>
                            ) : (
                                paginatedMembers.map(
                                    (member, index) => (
                                        <tr key={member.id}>

                                            <td>
                                                {startIndex +
                                                    index +
                                                    1}
                                            </td>

                                            <td>
                                                <div className="member-info">

                                                    <div className="member-avatar">

                                                        {member.profilePicture ? (
                                                            <img
                                                                src={
                                                                    member.profilePicture
                                                                }
                                                                alt={
                                                                    member.name
                                                                }
                                                            />
                                                        ) : (
                                                            <UserRound
                                                                size={19}
                                                            />
                                                        )}

                                                    </div>

                                                    <div>
                                                        <strong>
                                                            {
                                                                member.name
                                                            }
                                                        </strong>

                                                        <span>
                                                            {
                                                                member.memberId
                                                            }
                                                        </span>
                                                    </div>

                                                </div>
                                            </td>

                                            <td>
                                                <div className="mobile-cell">
                                                    <Phone
                                                        size={14}
                                                    />
                                                    {
                                                        member.mobile
                                                    }
                                                </div>
                                            </td>

                                            <td>
                                                <span className="gender-text">
                                                    {
                                                        member.gender
                                                    }
                                                </span>
                                            </td>

                                            <td>
                                                {calculateAge(
                                                    member.dob
                                                )}
                                            </td>

                                            <td>
                                                <div>
                                                    <strong>
                                                        {
                                                            member.community
                                                        }
                                                    </strong>

                                                    <small>
                                                        {
                                                            member.caste
                                                        }
                                                    </small>
                                                </div>
                                            </td>

                                            <td>
                                                {
                                                    member.highestEducation
                                                }
                                            </td>

                                            <td>
                                                {
                                                    member.profession
                                                }
                                            </td>

                                            <td>
                                                <div className="branch-cell">
                                                    <MapPin
                                                        size={14}
                                                    />
                                                    <span>
                                                        {
                                                            member.branch
                                                        }
                                                    </span>
                                                </div>
                                            </td>

                                            <td>
                                                <span
                                                    className={`plan-badge ${String(
                                                        member.subscriptionPlan
                                                    ).toLowerCase()}`}
                                                >
                                                    {
                                                        member.subscriptionPlan
                                                    }
                                                </span>
                                            </td>

                                            <td>
                                                <button
                                                    type="button"
                                                    className={`member-status-badge ${String(
                                                        member.status
                                                    ).toLowerCase()}`}
                                                    onClick={() =>
                                                        toggleStatus(
                                                            member
                                                        )
                                                    }
                                                    title="Click to change status"
                                                >
                                                    <span />
                                                    {
                                                        member.status
                                                    }
                                                </button>
                                            </td>

                                            <td>
                                                <div className="member-actions">

                                                    <button
                                                        type="button"
                                                        className="member-action view"
                                                        onClick={() =>
                                                            openView(
                                                                member
                                                            )
                                                        }
                                                        title="View"
                                                    >
                                                        <Eye
                                                            size={16}
                                                        />
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="member-action edit"
                                                        onClick={() =>
                                                            openEdit(
                                                                member
                                                            )
                                                        }
                                                        title="Edit"
                                                    >
                                                        <Pencil
                                                            size={16}
                                                        />
                                                    </button>

                                                </div>
                                            </td>

                                        </tr>
                                    )
                                )
                            )}

                        </tbody>

                    </table>

                </div>

                {/* PAGINATION */}

                <div className="members-pagination">

                    <div>
                        Showing{" "}
                        <strong>
                            {filteredMembers.length === 0
                                ? 0
                                : startIndex + 1}
                        </strong>{" "}
                        to{" "}
                        <strong>
                            {Math.min(
                                startIndex +
                                    rowsPerPage,
                                filteredMembers.length
                            )}
                        </strong>{" "}
                        of{" "}
                        <strong>
                            {filteredMembers.length}
                        </strong>
                    </div>

                    <div className="pagination-controls">

                        <select
                            value={rowsPerPage}
                            onChange={(e) => {
                                setRowsPerPage(
                                    Number(e.target.value)
                                );
                                setPage(1);
                            }}
                        >
                            <option value={10}>
                                10 / page
                            </option>
                            <option value={20}>
                                20 / page
                            </option>
                            <option value={50}>
                                50 / page
                            </option>
                        </select>

                        <button
                            type="button"
                            disabled={currentPage <= 1}
                            onClick={() =>
                                setPage((prev) =>
                                    Math.max(prev - 1, 1)
                                )
                            }
                        >
                            <ChevronLeft size={17} />
                        </button>

                        <span>
                            {currentPage} / {totalPages}
                        </span>

                        <button
                            type="button"
                            disabled={
                                currentPage >= totalPages
                            }
                            onClick={() =>
                                setPage((prev) =>
                                    Math.min(
                                        prev + 1,
                                        totalPages
                                    )
                                )
                            }
                        >
                            <ChevronRight size={17} />
                        </button>

                    </div>

                </div>

            </div>

            {/* =================================================
                ADD / EDIT MODAL
            ================================================= */}

            {showFormModal && (
                <div
                    className="member-modal-overlay"
                    onMouseDown={(e) => {
                        if (
                            e.target ===
                            e.currentTarget
                        ) {
                            closeForm();
                        }
                    }}
                >
                    <div className="member-form-modal">

                        <div className="member-modal-header">

                            <div>
                                <h2>
                                    {editingMember
                                        ? "Edit Member"
                                        : "Add Member"}
                                </h2>

                                <p>
                                    {editingMember
                                        ? "Update member profile information."
                                        : "Create a new matrimonial member profile."}
                                </p>
                            </div>

                            <button
                                type="button"
                                onClick={closeForm}
                            >
                                <X size={20} />
                            </button>

                        </div>

                        <form
                            onSubmit={handleSubmit}
                            className="member-form"
                        >

                            {/* BASIC */}

                            <FormSection
                                icon={UserRound}
                                title="Basic Information"
                            >
                                <FormInput
                                    label="Member ID"
                                    name="memberId"
                                    value={
                                        formData.memberId
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    required
                                />

                                <FormInput
                                    label="Member Name"
                                    name="name"
                                    value={
                                        formData.name
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    required
                                />

                                <FormSelect
                                    label="Gender"
                                    name="gender"
                                    value={
                                        formData.gender
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        genderOptions
                                    }
                                    required
                                />

                                <FormInput
                                    label="Date of Birth"
                                    name="dob"
                                    value={
                                        formData.dob
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    type="date"
                                    required
                                />

                                <FormInput
                                    label="Time of Birth"
                                    name="timeOfBirth"
                                    value={
                                        formData.timeOfBirth
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    type="time"
                                />

                                <FormInput
                                    label="Place of Birth"
                                    name="placeOfBirth"
                                    value={
                                        formData.placeOfBirth
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                />

                                <FormInput
                                    label="Mobile Number"
                                    name="mobile"
                                    value={
                                        formData.mobile
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    required
                                />

                                <FormInput
                                    label="Email Address"
                                    name="email"
                                    value={
                                        formData.email
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    type="email"
                                />
                            </FormSection>

                            {/* FAMILY */}

                            <FormSection
                                icon={Home}
                                title="Family Information"
                            >
                                <FormInput
                                    label="Father Name"
                                    name="fatherName"
                                    value={
                                        formData.fatherName
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                />

                                <FormInput
                                    label="Mother Name"
                                    name="motherName"
                                    value={
                                        formData.motherName
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                />

                                <FormInput
                                    label="Siblings"
                                    name="siblings"
                                    value={
                                        formData.siblings
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                />

                                <FormSelect
                                    label="Family Type"
                                    name="familyType"
                                    value={
                                        formData.familyType
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        familyTypeOptions
                                    }
                                />

                                <FormSelect
                                    label="Family Status"
                                    name="familyStatus"
                                    value={
                                        formData.familyStatus
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        familyStatusOptions
                                    }
                                />

                                <FormInput
                                    label="Family Temple"
                                    name="familyTemple"
                                    value={
                                        formData.familyTemple
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                />

                                <FormInput
                                    label="Family Temple Place"
                                    name="familyTemplePlace"
                                    value={
                                        formData.familyTemplePlace
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                />

                                <FormInput
                                    label="Family Assets"
                                    name="familyAssets"
                                    value={
                                        formData.familyAssets
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                />
                            </FormSection>

                            {/* COMMUNITY */}

                            <FormSection
                                icon={Users}
                                title="Community Information"
                            >
                                <FormSelect
                                    label="Religion"
                                    name="religion"
                                    value={
                                        formData.religion
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        religionOptions
                                    }
                                />

                                <FormSelect
                                    label="Community"
                                    name="community"
                                    value={
                                        formData.community
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        communityOptions
                                    }
                                />

                                <FormSelect
                                    label="Sub Community"
                                    name="subCommunity"
                                    value={
                                        formData.subCommunity
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        subCommunityOptions
                                    }
                                />

                                <FormSelect
                                    label="Caste"
                                    name="caste"
                                    value={
                                        formData.caste
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        casteOptions
                                    }
                                />

                                <FormSelect
                                    label="Mother Tongue"
                                    name="motherTongue"
                                    value={
                                        formData.motherTongue
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        motherTongueOptions
                                    }
                                />

                                <FormInput
                                    label="Native Place"
                                    name="nativePlace"
                                    value={
                                        formData.nativePlace
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                />
                            </FormSection>

                            {/* EDUCATION */}

                            <FormSection
                                icon={GraduationCap}
                                title="Education & Career"
                            >
                                <FormSelect
                                    label="Highest Education"
                                    name="highestEducation"
                                    value={
                                        formData.highestEducation
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        educationOptions
                                    }
                                />

                                <FormSelect
                                    label="Profession"
                                    name="profession"
                                    value={
                                        formData.profession
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        professionOptions
                                    }
                                />

                                <FormSelect
                                    label="Occupation"
                                    name="occupation"
                                    value={
                                        formData.occupation
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        occupationOptions
                                    }
                                />

                                <FormInput
                                    label="Company Name"
                                    name="companyName"
                                    value={
                                        formData.companyName
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                />

                                <FormInput
                                    label="Designation"
                                    name="designation"
                                    value={
                                        formData.designation
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                />

                                <FormSelect
                                    label="Annual Income"
                                    name="annualIncome"
                                    value={
                                        formData.annualIncome
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        annualIncomeOptions
                                    }
                                />

                                <FormInput
                                    label="Work Location"
                                    name="workLocation"
                                    value={
                                        formData.workLocation
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                />
                            </FormSection>

                            {/* PERSONAL */}

                            <FormSection
                                icon={Heart}
                                title="Personal Information"
                            >
                                <FormInput
                                    label="Height"
                                    name="height"
                                    value={
                                        formData.height
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    placeholder="Example: 5.8"
                                />

                                <FormInput
                                    label="Weight (Kg)"
                                    name="weight"
                                    value={
                                        formData.weight
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                />

                                <FormSelect
                                    label="Color / Complexion"
                                    name="complexion"
                                    value={
                                        formData.complexion
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        complexionOptions
                                    }
                                />

                                <FormSelect
                                    label="Body Type"
                                    name="bodyType"
                                    value={
                                        formData.bodyType
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        bodyTypeOptions
                                    }
                                />

                                <FormSelect
                                    label="Marital Status"
                                    name="maritalStatus"
                                    value={
                                        formData.maritalStatus
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        maritalStatusOptions
                                    }
                                />

                                <FormSelect
                                    label="Blood Group"
                                    name="bloodGroup"
                                    value={
                                        formData.bloodGroup
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        bloodGroupOptions
                                    }
                                />
                            </FormSection>

                            {/* LOCATION */}

                            <FormSection
                                icon={MapPin}
                                title="Location Information"
                            >
                                <FormInput
                                    label="Country"
                                    name="country"
                                    value={
                                        formData.country
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    required
                                />

                                <FormSelect
                                    label="State"
                                    name="state"
                                    value={
                                        formData.state
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={states}
                                    required
                                />

                                <FormSelect
                                    label="District"
                                    name="district"
                                    value={
                                        formData.district
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={districts}
                                    disabled={
                                        !formData.state
                                    }
                                    required
                                />

                                <FormSelect
                                    label="Taluk"
                                    name="taluk"
                                    value={
                                        formData.taluk
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={taluks}
                                    disabled={
                                        !formData.district
                                    }
                                />

                                <FormSelect
                                    label="City"
                                    name="city"
                                    value={
                                        formData.city
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={cities}
                                    disabled={
                                        !formData.taluk
                                    }
                                />

                                <FormInput
                                    label="PIN Code"
                                    name="pincode"
                                    value={
                                        formData.pincode
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    required
                                />
                            </FormSection>

                            {/* HOROSCOPE */}

                            <FormSection
                                icon={Star}
                                title="Horoscope Information"
                            >
                                <FormSelect
                                    label="Star / Nakshatra"
                                    name="star"
                                    value={
                                        formData.star
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={starOptions}
                                />

                                <FormSelect
                                    label="Rasi"
                                    name="rasi"
                                    value={
                                        formData.rasi
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={rasiOptions}
                                />

                                <FormSelect
                                    label="Dosham"
                                    name="dosham"
                                    value={
                                        formData.dosham
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={doshamOptions}
                                />

                                <FormSelect
                                    label="Horoscope"
                                    name="horoscope"
                                    value={
                                        formData.horoscope
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={[
                                        "Available",
                                        "Not Available",
                                    ]}
                                />
                            </FormSection>

                            {/* PROFILE */}

                            <FormSection
                                icon={ShieldCheck}
                                title="Profile & Subscription"
                            >
                                <FormInput
                                    label="Profile Picture URL"
                                    name="profilePicture"
                                    value={
                                        formData.profilePicture
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    placeholder="https://..."
                                />

                                <FormSelect
                                    label="Profile Created By"
                                    name="profileCreatedBy"
                                    value={
                                        formData.profileCreatedBy
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        profileCreatedByOptions
                                    }
                                />

                                <FormSelect
                                    label="Subscription Plan"
                                    name="subscriptionPlan"
                                    value={
                                        formData.subscriptionPlan
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        subscriptionOptions
                                    }
                                />

                                <FormSelect
                                    label="Branch"
                                    name="branch"
                                    value={
                                        formData.branch
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        branchOptions
                                    }
                                    required
                                />

                                <FormSelect
                                    label="Profile Status"
                                    name="status"
                                    value={
                                        formData.status
                                    }
                                    onChange={
                                        handleFormChange
                                    }
                                    options={
                                        statusOptions
                                    }
                                    required
                                />
                            </FormSection>

                            {/* FORM FOOTER */}

                            <div className="member-form-footer">

                                <button
                                    type="button"
                                    className="member-cancel-btn"
                                    onClick={closeForm}
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    className="member-save-btn"
                                >
                                    {editingMember ? (
                                        <Save size={17} />
                                    ) : (
                                        <Plus size={17} />
                                    )}

                                    {editingMember
                                        ? "Update Member"
                                        : "Save Member"}
                                </button>

                            </div>

                        </form>
                    </div>
                </div>
            )}

            {/* =================================================
                VIEW MODAL
            ================================================= */}

            {showViewModal &&
                viewingMember && (
                    <div
                        className="member-modal-overlay"
                        onMouseDown={(e) => {
                            if (
                                e.target ===
                                e.currentTarget
                            ) {
                                setShowViewModal(false);
                            }
                        }}
                    >
                        <div className="member-view-modal">

                            <div className="member-modal-header">

                                <div>
                                    <h2>
                                        Member Profile
                                    </h2>

                                    <p>
                                        {
                                            viewingMember.memberId
                                        }
                                    </p>
                                </div>

                                <button
                                    type="button"
                                    onClick={() =>
                                        setShowViewModal(
                                            false
                                        )
                                    }
                                >
                                    <X size={20} />
                                </button>

                            </div>

                            <div className="member-view-content">

                                {/* PROFILE HEADER */}

                                <div className="member-profile-banner">

                                    <div className="member-profile-avatar">

                                        {viewingMember.profilePicture ? (
                                            <img
                                                src={
                                                    viewingMember.profilePicture
                                                }
                                                alt={
                                                    viewingMember.name
                                                }
                                            />
                                        ) : (
                                            <UserRound
                                                size={36}
                                            />
                                        )}

                                    </div>

                                    <div className="member-profile-main">

                                        <h2>
                                            {
                                                viewingMember.name
                                            }
                                        </h2>

                                        <p>
                                            {
                                                viewingMember.memberId
                                            }
                                        </p>

                                        <div className="member-profile-tags">

                                            <span>
                                                {
                                                    viewingMember.gender
                                                }
                                            </span>

                                            <span>
                                                {
                                                    viewingMember.community
                                                }
                                            </span>

                                            <span>
                                                {
                                                    viewingMember.subscriptionPlan
                                                }
                                            </span>

                                        </div>

                                    </div>

                                    <div>
                                        <span
                                            className={`member-status-badge ${String(
                                                viewingMember.status
                                            ).toLowerCase()}`}
                                        >
                                            <span />
                                            {
                                                viewingMember.status
                                            }
                                        </span>
                                    </div>

                                </div>

                                {/* BASIC */}

                                <ViewSection
                                    title="Basic Information"
                                    icon={UserRound}
                                >
                                    <ViewItem
                                        label="Member ID"
                                        value={
                                            viewingMember.memberId
                                        }
                                    />

                                    <ViewItem
                                        label="Name"
                                        value={
                                            viewingMember.name
                                        }
                                    />

                                    <ViewItem
                                        label="Gender"
                                        value={
                                            viewingMember.gender
                                        }
                                    />

                                    <ViewItem
                                        label="Date of Birth"
                                        value={
                                            viewingMember.dob
                                        }
                                    />

                                    <ViewItem
                                        label="Age"
                                        value={`${calculateAge(
                                            viewingMember.dob
                                        )} Years`}
                                    />

                                    <ViewItem
                                        label="Time of Birth"
                                        value={
                                            viewingMember.timeOfBirth
                                        }
                                    />

                                    <ViewItem
                                        label="Place of Birth"
                                        value={
                                            viewingMember.placeOfBirth
                                        }
                                    />

                                    <ViewItem
                                        label="Mobile"
                                        value={
                                            viewingMember.mobile
                                        }
                                    />

                                    <ViewItem
                                        label="Email"
                                        value={
                                            viewingMember.email
                                        }
                                    />
                                </ViewSection>

                                {/* FAMILY */}

                                <ViewSection
                                    title="Family Information"
                                    icon={Home}
                                >
                                    <ViewItem
                                        label="Father"
                                        value={
                                            viewingMember.fatherName
                                        }
                                    />

                                    <ViewItem
                                        label="Mother"
                                        value={
                                            viewingMember.motherName
                                        }
                                    />

                                    <ViewItem
                                        label="Siblings"
                                        value={
                                            viewingMember.siblings
                                        }
                                    />

                                    <ViewItem
                                        label="Family Type"
                                        value={
                                            viewingMember.familyType
                                        }
                                    />

                                    <ViewItem
                                        label="Family Status"
                                        value={
                                            viewingMember.familyStatus
                                        }
                                    />

                                    <ViewItem
                                        label="Family Temple"
                                        value={
                                            viewingMember.familyTemple
                                        }
                                    />

                                    <ViewItem
                                        label="Temple Place"
                                        value={
                                            viewingMember.familyTemplePlace
                                        }
                                    />

                                    <ViewItem
                                        label="Family Assets"
                                        value={
                                            viewingMember.familyAssets
                                        }
                                    />
                                </ViewSection>

                                {/* COMMUNITY */}

                                <ViewSection
                                    title="Community"
                                    icon={Users}
                                >
                                    <ViewItem
                                        label="Religion"
                                        value={
                                            viewingMember.religion
                                        }
                                    />

                                    <ViewItem
                                        label="Community"
                                        value={
                                            viewingMember.community
                                        }
                                    />

                                    <ViewItem
                                        label="Sub Community"
                                        value={
                                            viewingMember.subCommunity
                                        }
                                    />

                                    <ViewItem
                                        label="Caste"
                                        value={
                                            viewingMember.caste
                                        }
                                    />

                                    <ViewItem
                                        label="Mother Tongue"
                                        value={
                                            viewingMember.motherTongue
                                        }
                                    />
                                </ViewSection>

                                {/* EDUCATION */}

                                <ViewSection
                                    title="Education & Career"
                                    icon={
                                        GraduationCap
                                    }
                                >
                                    <ViewItem
                                        label="Education"
                                        value={
                                            viewingMember.highestEducation
                                        }
                                    />

                                    <ViewItem
                                        label="Profession"
                                        value={
                                            viewingMember.profession
                                        }
                                    />

                                    <ViewItem
                                        label="Occupation"
                                        value={
                                            viewingMember.occupation
                                        }
                                    />

                                    <ViewItem
                                        label="Company"
                                        value={
                                            viewingMember.companyName
                                        }
                                    />

                                    <ViewItem
                                        label="Designation"
                                        value={
                                            viewingMember.designation
                                        }
                                    />

                                    <ViewItem
                                        label="Annual Income"
                                        value={
                                            viewingMember.annualIncome
                                        }
                                    />

                                    <ViewItem
                                        label="Work Location"
                                        value={
                                            viewingMember.workLocation
                                        }
                                    />
                                </ViewSection>

                                {/* PERSONAL */}

                                <ViewSection
                                    title="Personal Information"
                                    icon={Heart}
                                >
                                    <ViewItem
                                        label="Height"
                                        value={
                                            viewingMember.height
                                        }
                                    />

                                    <ViewItem
                                        label="Weight"
                                        value={
                                            viewingMember.weight
                                        }
                                    />

                                    <ViewItem
                                        label="Complexion"
                                        value={
                                            viewingMember.complexion
                                        }
                                    />

                                    <ViewItem
                                        label="Body Type"
                                        value={
                                            viewingMember.bodyType
                                        }
                                    />

                                    <ViewItem
                                        label="Marital Status"
                                        value={
                                            viewingMember.maritalStatus
                                        }
                                    />

                                    <ViewItem
                                        label="Blood Group"
                                        value={
                                            viewingMember.bloodGroup
                                        }
                                    />
                                </ViewSection>

                                {/* LOCATION */}

                                <ViewSection
                                    title="Location"
                                    icon={MapPin}
                                >
                                    <ViewItem
                                        label="Country"
                                        value={
                                            viewingMember.country
                                        }
                                    />

                                    <ViewItem
                                        label="State"
                                        value={
                                            viewingMember.state
                                        }
                                    />

                                    <ViewItem
                                        label="District"
                                        value={
                                            viewingMember.district
                                        }
                                    />

                                    <ViewItem
                                        label="Taluk"
                                        value={
                                            viewingMember.taluk
                                        }
                                    />

                                    <ViewItem
                                        label="City"
                                        value={
                                            viewingMember.city
                                        }
                                    />

                                    <ViewItem
                                        label="PIN Code"
                                        value={
                                            viewingMember.pincode
                                        }
                                    />

                                    <ViewItem
                                        label="Native Place"
                                        value={
                                            viewingMember.nativePlace
                                        }
                                    />
                                </ViewSection>

                                {/* HOROSCOPE */}

                                <ViewSection
                                    title="Horoscope"
                                    icon={Star}
                                >
                                    <ViewItem
                                        label="Star"
                                        value={
                                            viewingMember.star
                                        }
                                    />

                                    <ViewItem
                                        label="Rasi"
                                        value={
                                            viewingMember.rasi
                                        }
                                    />

                                    <ViewItem
                                        label="Dosham"
                                        value={
                                            viewingMember.dosham
                                        }
                                    />

                                    <ViewItem
                                        label="Horoscope"
                                        value={
                                            viewingMember.horoscope
                                        }
                                    />
                                </ViewSection>

                                {/* SUBSCRIPTION */}

                                <ViewSection
                                    title="Profile & Subscription"
                                    icon={
                                        ShieldCheck
                                    }
                                >
                                    <ViewItem
                                        label="Profile Created By"
                                        value={
                                            viewingMember.profileCreatedBy
                                        }
                                    />

                                    <ViewItem
                                        label="Subscription"
                                        value={
                                            viewingMember.subscriptionPlan
                                        }
                                    />

                                    <ViewItem
                                        label="Branch"
                                        value={
                                            viewingMember.branch
                                        }
                                    />

                                    <ViewItem
                                        label="Status"
                                        value={
                                            viewingMember.status
                                        }
                                    />

                                    <ViewItem
                                        label="Created Date"
                                        value={
                                            viewingMember.createdDate
                                        }
                                    />
                                </ViewSection>

                            </div>

                            <div className="member-view-footer">

                                <button
                                    type="button"
                                    className="member-cancel-btn"
                                    onClick={() =>
                                        setShowViewModal(
                                            false
                                        )
                                    }
                                >
                                    Close
                                </button>

                                <button
                                    type="button"
                                    className="member-save-btn"
                                    onClick={() => {
                                        setShowViewModal(
                                            false
                                        );
                                        openEdit(
                                            viewingMember
                                        );
                                    }}
                                >
                                    <Pencil size={16} />
                                    Edit Member
                                </button>

                            </div>

                        </div>
                    </div>
                )}

        </div>
    );
}

/* =========================================================
   VIEW SECTION
========================================================= */

function ViewSection({
    title,
    icon: Icon,
    children,
}) {
    return (
        <div className="member-view-section">

            <div className="member-view-section-title">

                <div>
                    <Icon size={17} />
                </div>

                <h3>{title}</h3>

            </div>

            <div className="member-view-grid">
                {children}
            </div>

        </div>
    );
}

/* =========================================================
   VIEW ITEM
========================================================= */

function ViewItem({ label, value }) {
    return (
        <div className="member-view-item">
            <span>{label}</span>
            <strong>
                {value || "-"}
            </strong>
        </div>
    );
}

/* =========================================================
   AGE CALCULATOR
========================================================= */

function calculateAge(dateString) {
    if (!dateString) return "-";

    const today = new Date();
    const birthDate = new Date(dateString);

    let age =
        today.getFullYear() -
        birthDate.getFullYear();

    const monthDifference =
        today.getMonth() -
        birthDate.getMonth();

    if (
        monthDifference < 0 ||
        (monthDifference === 0 &&
            today.getDate() <
                birthDate.getDate())
    ) {
        age--;
    }

    return age;
}

export default Members;